(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3880],{

/***/ 94232:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]",
      function () {
        return __webpack_require__(58420);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ verifyAuth; },
/* harmony export */   "bG": function() { return /* binding */ sendAuthOtp; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "kS": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);






/**
 * send otp to verify mobile number for authentication
 * @param mobileNo target mobile number
 * @param lang otp langauge message
 * @returns reference number otp and is found user in retail platform flag
 */ var sendAuthOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(mobileNo, lang) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/send-otp", {
                            mobileNo: mobileNo
                        }, {
                            headers: {
                                "Accept-Language": lang
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendAuthOtp(mobileNo, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * get user profile from access token in cookies
 * @returns user's profile
 */ var getUserProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/retail/auth/user/me")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserProfile() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function to verify authentication.
 * @return atk, rtk, isAlreadyRegistered and expired datetime
 */ var verifyAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(payload) {
        var res, result, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/login", payload)
                    ];
                case 1:
                    res = _state.sent();
                    result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.data), {
                        timestamp: res.headers.date
                    });
                    return [
                        2,
                        result
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function verifyAuth(payload) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * logout by access token in cookies
 * @returns empty object
 */ var logout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/logout", {}, {
                            withCredentials: true,
                            headers: {
                                credentials: "same-origin"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function logout() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 47363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s0": function() { return /* binding */ getProductCategoryActiveList; }
/* harmony export */ });
/* unused harmony exports getProductCategoryActiveListViaServerSide, getProductCategoryByCode */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var _http_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55642);




var getProductCategoryActiveList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.get */ .hL.get("/channels/".concat(channelCode, "/product-categories/active-list"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getProductCategoryActiveList(channelCode) {
        return _ref.apply(this, arguments);
    };
}();
var getProductCategoryActiveListViaServerSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(channelCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .serverHttpInstance.get */ .H$.get("/channels/".concat(channelCode, "/product-categories/active-list"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getProductCategoryActiveListViaServerSide(channelCode) {
        return _ref.apply(this, arguments);
    };
}();
var getProductCategoryByCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(code, channelCode) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .serverHttpInstance.get */ .H$.get("/channels/".concat(channelCode, "/product-categories/").concat(code))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getProductCategoryByCode(code, channelCode) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 94665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_api_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36707);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(435);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85760);










// allow user or guest to access this page
// if user is authorized, header will display user header with user data to child component.
// if user not authorized, header will display guest header and able to log in/sign up.
var withUserOrGuest = function(WrappedComponent) {
    return function(props) {
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), user = ref[0], setUser = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadSuccess = ref1[0], setIsLoadSuccess = ref1[1];
        var isRetail = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            var fetchGetProfile = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0,src_api_auth__WEBPACK_IMPORTED_MODULE_6__/* .getUserProfile */ .et)()
                                ];
                            case 1:
                                result = _state.sent();
                                setUser(result);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                setUser(null);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                setIsLoadSuccess(true);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchGetProfile() {
                    return _ref.apply(this, arguments);
                };
            }();
            // fetch user data once only, prevent unnecessary fetch from other state.
            if (!isLoadSuccess) {
                fetchGetProfile();
            }
        }, [
            isLoadSuccess,
            router
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isLoadSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                user: user,
                headerType: isRetail ? src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PROFILE */ .N.PROFILE : src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PARTNER */ .N.PARTNER
            }))
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withUserOrGuest);


/***/ }),

/***/ 37731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EV": function() { return /* binding */ DROP_LEAD_FORM_VALUES; },
/* harmony export */   "Oe": function() { return /* binding */ DROP_LEAD_ANCHOR; },
/* harmony export */   "xh": function() { return /* binding */ DROP_LEAD_FORM_FIELDS; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var DROP_LEAD_FORM_FIELDS = {
    FULL_NAME: "fullName",
    MOBILE_NO: "mobileNo",
    AVAILABLE_CALL_DAY: "availableCallDay",
    AVAILABLE_CALL_WEEKDAY: "availableCallWeekDay",
    AVAILABLE_CALL_WEEKEND: "availableCallWeekEnd",
    AVAILABLE_CALL_TIME: "availableCallTime",
    INTERESTED_PRODUCTS: "interestedProducts",
    DETAIL: "detail",
    EMAIL: "email",
    S_REF_CODE: "sRefCode",
    IS_ACCEPT_ALL_TC: "isAcceptAllTc"
};
var DROP_LEAD_FORM_VALUES = {
    AVAILABLE_CALL_TIME: {
        ANYTIME: "Anytime",
        MORNING: "08:00 - 12:00",
        NOON: "12:00 - 13:00",
        AFTERNOON: "13:00 - 17:00",
        EVENING: "17:00 - 20:00"
    },
    DETAIL_PA: {
        en: "> Health: (Age....  Date of birth.........)\n> Motor:  (Brand....  Model....  Year.... )\n> Gadget: (Brand....  Model....  Year.... )\n> Home: (Type....  Floor count....)\n\nFor Free PA Songkarn\n> id card number:\n> date of birth (DD/MM/YYYY):\n\nOr, any special request:",
        th: "> สุขภาพ: (อายุ...  วัน เดือน ปีเกิด.........)\n> รถยนต์:  (ยี่ห้อ....  รุ่น....  ปีที่ผลิต.... )\n> อุปกรณ์อิเล็กทรอนิกส์: (ยี่ห้อ....  รุ่น....  ปีที่ผลิต.... )\n> บ้าน: (ประเภท....  จำนวนชั้น....)\n\nสำหรับโครงการ Free PA สงกรานต์\n> เลขบัตรประชาชน 13 หลัก:\n> วันเดือนปีเกิด (DD/MM/YYYY):\n\nหรือระบุความต้องการอื่นๆ เพิ่มเติม"
    },
    DETAIL_DEFAULT: {
        en: "> Health: (Age....  Date of birth.........)\n> Motor:  (Brand....  Model....  Year.... )\n> Gadget: (Brand....  Model....  Year.... )\n> Home: (Type....  Floor count....)\n\nOr, any special request:",
        th: "> สุขภาพ: (อายุ...  วัน เดือน ปีเกิด.........)\n> รถยนต์:  (ยี่ห้อ....  รุ่น....  ปีที่ผลิต.... )\n> อุปกรณ์อิเล็กทรอนิกส์: (ยี่ห้อ....  รุ่น....  ปีที่ผลิต.... )\n> บ้าน: (ประเภท....  จำนวนชั้น....)\n\nหรือระบุความต้องการอื่นๆ เพิ่มเติม"
    },
    INTERESTED_PRODUCT: {
        HEALTH: "HEALTH",
        HEALTH_ADULT: "HEALTH_ADULT",
        HEALTH_KID: "HEALTH_KID",
        HEALTH_PA: "HEALTH_PA",
        CI: "CI",
        MOTOR: "MOTOR",
        GADGET: "GADGET",
        HOME: "HOME"
    }
};
var DROP_LEAD_ANCHOR = "drop-lead";


/***/ }),

/***/ 58420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14744);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85760);
/* harmony import */ var src_constants_dropLeadForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37731);
/* harmony import */ var src_components_Layout_withLayout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20587);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_Auth_withUserOrGuest__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94665);
/* harmony import */ var _api_productCategory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47363);
/* eslint-disable react/button-has-type */ 













var Banner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 3758).then(__webpack_require__.bind(__webpack_require__, 83758));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83758)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var ProductCategory = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(1509), __webpack_require__.e(8837), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(7751), __webpack_require__.e(7036), __webpack_require__.e(1017)]).then(__webpack_require__.bind(__webpack_require__, 91017));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91017)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var RetailProductCategory = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(1509), __webpack_require__.e(8837), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(7751), __webpack_require__.e(8371), __webpack_require__.e(2716), __webpack_require__.e(2590)]).then(__webpack_require__.bind(__webpack_require__, 12590));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12590)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var ContactUs = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 539).then(__webpack_require__.bind(__webpack_require__, 20539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20539)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var HighlightPlan = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(1747), __webpack_require__.e(1173), __webpack_require__.e(2660)]).then(__webpack_require__.bind(__webpack_require__, 82660));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82660)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var USPBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 5789).then(__webpack_require__.bind(__webpack_require__, 65789));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65789)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var USPList = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(7751), __webpack_require__.e(3114)]).then(__webpack_require__.bind(__webpack_require__, 11372));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11372)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var Partner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6095).then(__webpack_require__.bind(__webpack_require__, 46095));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46095)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var DropLead = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(6422), __webpack_require__.e(6203), __webpack_require__.e(1029), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4542), __webpack_require__.e(6168)]).then(__webpack_require__.bind(__webpack_require__, 6168));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6168)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var PopupAdsContent = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2809).then(__webpack_require__.bind(__webpack_require__, 2809));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2809)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
});
var HomePage = function(param) {
    var channelPath = param.channelPath, channelCode = param.channelCode, USPBannerProps = param.USPBannerProps, USPitemsProps = param.USPitemsProps, bannerProps = param.bannerProps, partnerProps = param.partnerProps, sRefCode = param.sRefCode, isFromCarnival = param.isFromCarnival, channelConfig = param.channelConfig;
    var ref, ref1;
    var content = channelConfig.content;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isFromDropLead = ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) === src_constants_dropLeadForm__WEBPACK_IMPORTED_MODULE_4__/* .DROP_LEAD_ANCHOR */ .Oe;
    var isRET = channelConfig.logicalGroupChannelCode === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), productCategories = ref2[0], setProductCategories = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var getProductCategories = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var productCat, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,_api_productCategory__WEBPACK_IMPORTED_MODULE_8__/* .getProductCategoryActiveList */ .s0)(channelCode)
                            ];
                        case 2:
                            productCat = _state.sent();
                            setProductCategories(productCat.sort(function(a, b) {
                                return a.seq - b.seq;
                            }));
                            setIsLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            (0,src_utils_logger__WEBPACK_IMPORTED_MODULE_9__/* .logError */ .H)("Error fetch product category", {
                                error: error
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getProductCategories() {
                return _ref.apply(this, arguments);
            };
        }();
        getProductCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Banner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, bannerProps), {
                content: content,
                isRET: isRET
            })),
            !isRET && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCategory, {
                isRET: isRET,
                isLoading: isLoading,
                productCategories: productCategories,
                channelPath: channelPath,
                content: content
            }),
            isRET && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RetailProductCategory, {
                isLoading: isLoading,
                productCategories: productCategories,
                channelPath: channelPath,
                content: content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HighlightPlan, {
                content: content,
                isRET: isRET
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUs, {
                content: content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(USPBanner, {
                image: USPBannerProps.image,
                content: content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(USPList, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, USPitemsProps), {
                content: content
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Partner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, partnerProps), {
                content: content
            })),
            (content === null || content === void 0 ? void 0 : (ref1 = content.dropLead) === null || ref1 === void 0 ? void 0 : ref1.enabled) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropLead, {
                channelConfig: channelConfig,
                sRefCode: sRefCode,
                isFromCarnival: isFromCarnival,
                channelPath: channelPath
            }),
            !isFromDropLead && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopupAdsContent, {
                content: content
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,src_components_Auth_withUserOrGuest__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,src_components_Layout_withLayout__WEBPACK_IMPORTED_MODULE_13__/* .withLayout */ .X)(HomePage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3640,6322,587,9774,2888,179], function() { return __webpack_exec__(94232); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);